var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-container"},_vm._l((_vm.list),function(item,index){return _c('van-tag',{key:index,staticClass:"tag",attrs:{"round":""},on:{"click":function($event){return _vm.doChoose(item)}}},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }